export const formatPhone = (phone) => {
  const temp = phone.replace(/-/g, '');
  if (temp.length === 10) {
    return temp.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  } else if (temp.length === 11) {
    return temp.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  return phone;
};
